// lib/execCards.mjs — R115 fix (review exec#2): how an Executive Summary card
// reads when its number is missing. Plain ESM so `node lib/execCards.test.mjs`
// tests the exact code ExecSummaryPage.ts runs; types in execCards.d.mts.
//
// GET /api/exec-summary answers each card as { value, error?, … }. A card
// whose source failed is { value: null, error } — it must NEVER render like a
// healthy card: not green, not the "all clear" caption, not "no responses
// yet". It renders amber (tone-warn — main.css), shows the error, says the
// dash is not a zero, and stays static (nothing to drill into).
//
// kinds:
//   'exception' — a count where 0 is good news (past-due tasks, at-risk
//                 arrivals, payment flags …): 0 → tone-good, >0 → tone-bad;
//   'growth'    — a count where more is good (properties added): >0 → good;
//   'neutral'   — no tone from the number (bookings, MTR vacancies …; the
//                 caller may still pass its own tone for a real value).
// A null value WITHOUT an error is "no data yet" only for cards that have
// such a state (owner NPS with no responses) — pass `emptyOk: true`.

export function failedText(x) {
  const e = x && x.error != null ? String(x.error).trim() : '';
  return `${e || 'unavailable right now'} (not zero)`;
}

export function cardState(x, kind = 'exception', opts = {}) {
  const v = x && x.value != null ? x.value : null;
  const err = !!(x && x.error != null && String(x.error).trim() !== '');
  if (v == null) {
    if (!err && opts.emptyOk) return { failed: false, empty: true, tone: '', clickable: false, cap: null };
    return { failed: true, empty: false, tone: 'tone-warn', clickable: false, cap: failedText(x) };
  }
  const n = Number(v);
  const any = Number.isFinite(n) ? n !== 0 : !!v;
  const tone = kind === 'exception' ? (any ? 'tone-bad' : 'tone-good')
    : kind === 'growth' ? (any ? 'tone-good' : '')
      : '';
  return { failed: false, empty: false, tone, clickable: !err, cap: null };
}
